import { BeforeItemDropZone } from "@ext/navigation/catalog/SidebarNavigation/components/SidebarDragnDrop/BeforeItemDropZone";
import {
	DraggableSideMenuItemContent,
	ItemDroppable,
} from "@ext/navigation/catalog/SidebarNavigation/components/SidebarDragnDrop/ItemDndBindings";
import { ItemDragInsertionLine } from "@ext/navigation/catalog/SidebarNavigation/components/SidebarDragnDrop/ItemDragInsertionLine";
import { SidebarInsertionLine } from "@ext/navigation/catalog/SidebarNavigation/components/SidebarInsertionLine/SidebarInsertionLine";
import { VerticalLineSegment } from "@ext/navigation/catalog/SidebarNavigation/components/SidebarInsertionLine/VerticalLineSegment";
import type { useInsertionLineState } from "@ext/navigation/catalog/SidebarNavigation/hooks/useInsertionLineState";
import type { DragLineState, useItemDndState } from "@ext/navigation/catalog/SidebarNavigation/hooks/useItemDndState";
import { getTreeId } from "@ext/navigation/catalog/SidebarNavigation/utils/getTreeId";
import type { ItemLink } from "@ext/navigation/NavigationLinks";
import type { MutableRefObject } from "react";

interface EditArticleItemProps {
	data: ItemLink;
	level: number;
	isNested: boolean;
	isSelected: boolean;
	itemRef: MutableRefObject<HTMLDivElement>;
	dnd: ReturnType<typeof useItemDndState>;
	insertionLine: ReturnType<typeof useInsertionLineState>;
	dragLine: DragLineState;
	onSelect: () => void;
	onAddChild?: () => void;
}

export const EditArticleItem = ({
	data,
	level,
	isNested,
	isSelected,
	itemRef,
	dnd,
	insertionLine,
	dragLine,
	onSelect,
	onAddChild,
}: EditArticleItemProps) => {
	const { isDragging, isInsertionTarget, isDragTarget, dropMode, isDragLocked, isUndraggable } = dnd;
	const treeId = getTreeId(data);
	const { minDepth, maxDepth, handleAdd, handleParentHover, showsLine, isAnchor } = insertionLine;
	const { showsDragLine, isDragAnchor } = dragLine;

	return (
		<ItemDroppable id={treeId} itemRef={itemRef}>
			<BeforeItemDropZone itemId={treeId} />
			{(showsLine || (showsDragLine && level > 1)) && (
				<VerticalLineSegment className={isAnchor || isDragAnchor ? "bottom-[0.3125rem]" : undefined} />
			)}
			<DraggableSideMenuItemContent
				data={data}
				disabled={isDragLocked}
				id={treeId}
				isCategory={false}
				isDragging={isDragging}
				isDropTarget={isDragTarget}
				isInsertionTarget={isInsertionTarget}
				isNested={isNested}
				isSelected={isSelected}
				level={level}
				onAddChild={onAddChild}
				onSelect={onSelect}
				undraggable={isUndraggable}
			/>
			<SidebarInsertionLine
				className="-bottom-[0.3125rem]"
				level={level}
				maxDepth={maxDepth}
				minDepth={minDepth}
				onAdd={handleAdd}
				onParentHover={handleParentHover}
			/>
			<ItemDragInsertionLine dropMode={dropMode} />
		</ItemDroppable>
	);
};
